import * as React from "react";
import { format } from "../utils";
import { Product, Sku } from "../types";
import classNames from "classnames";
import t from "../i18n";
import { SkuCategory } from "../types-enums";
import { skuCardStyles } from "../_styles/skucard";
import { css } from "emotion";

declare type OrderProps = {
    product: Product;
    selectedSkuId: number | undefined;
    sourceCurrencyCode: string;
    onSkuSelected: (sku: Sku | undefined) => void;
    selectedSkuCategory: SkuCategory | undefined;
    showTopupTabFirst: boolean | false;
}
export default class Order extends React.Component<OrderProps, { dataSku: boolean }> {
    constructor(props: OrderProps) {
        super(props);
        if (props.selectedSkuId) {
            const isRegularSku = props.product.skus.some(s => s.skuId === props.selectedSkuId);
            this.state = { dataSku: !isRegularSku };
        } 
        else if(props.product && props.product.skus!=null && props.product.skus.length == 0 ){
            this.state = { dataSku: true};
        }
        else {
            this.state = { dataSku: !props.showTopupTabFirst };
            // if(this.props.product.dataSkus){
            //     this.state = { dataSku: true };
            // }
            // else{
            //     this.state = { dataSku: false };
            // }
        }
    }

    async componentDidMount(){
        if( !this.props.selectedSkuId && this.props.selectedSkuCategory && this.props.selectedSkuCategory == SkuCategory.Topup)
        {
            this.setState({ dataSku: false });
        }
    }
    renderPromotion(sku: Sku) {
        if (sku.lines===null) return;
        const line1 = sku.lines.length > 0 ? sku.lines[0] : null;
        const line2 = sku.lines.length > 1 ? sku.lines[1] : null;
        const line3 = sku.lines.length > 2 ? sku.lines[2] : null;
        const line4 = sku.lines.length > 3 ? sku.lines[3] : null;
        const footNote = sku.footNote;
        if (sku.lines.length > 0 || footNote) {
            return (<div style={{ marginTop: 5 }}>
                {line1 && <div className={classNames("promo-sku", css(skuCardStyles.promoLineStyle))}>{line1}</div>}
                {line2 && <div className={classNames("promo-sku", css(skuCardStyles.promoLineStyle))}>{line2}</div>}
                {line3 && <div className={classNames("promo-sku", css(skuCardStyles.promoLineStyle))}>{line3}</div>}
                {line4 && <div className={classNames("promo-sku", css(skuCardStyles.promoLineStyle))}>{line4}</div>}
                {footNote && <div className={classNames('promo-sku-footnote', css(skuCardStyles.promoFootNoteStyle))}>{footNote}</div>}
            </div >
            );
        } else {
            return null;
        }
    }
    renderSku(sku: Sku) {
        const product = this.props.product;
        const targetCurrency = this.props.product.country.currencyCode;
        const sourceCurrency = this.props.sourceCurrencyCode;
        const isSelected = sku.skuId === this.props.selectedSkuId;
        const selectedClass = isSelected ? "selected": "";
        return <label key={sku.skuId} className={classNames(["form-group-small eto-card", selectedClass])}>
            <div style={{ fontSize: "24px", fontWeight: "bold" }}>{format(sku.faceValue)} {sourceCurrency}</div>
            {(targetCurrency !== sourceCurrency) && <div>({format(sku.localCurrencyAmount)} {product.country.currencyCode})</div>}
            {this.renderPromotion(sku)}
            <div style={{ marginTop: 5 }}>
                <input type="radio" name="select-amount" checked={isSelected} value={sku.skuId} onChange={e => this.props.onSkuSelected(sku)} />
            </div>
        </label>
    }
    renderDataSku(sku: Sku) {
        const sourceCurrency: string = this.props.sourceCurrencyCode;
        const isSelected = sku.skuId === this.props.selectedSkuId;
        const selectedClass = isSelected ? "selected": "";
        return (
            <label className={classNames(["form-group-small eto-card", selectedClass])}>
                <div style={{ fontSize: "24px", fontWeight: "bold" }}>{sku.shortDescription}</div>
                <div>({sku.faceValue} {sourceCurrency})</div>
                {this.renderPromotion(sku)}
                <div style={{ marginTop: 5 }}>
                    <input type="radio" name="select-amount" checked={isSelected} value={sku.skuId} onChange={e => this.props.onSkuSelected(sku)} />
                </div>
            </label>
        );
    }
    onTabChanged = (isDataSku: boolean) => {
        this.setState({ dataSku: isDataSku })
        // this.props.onSkuSelected(undefined);
    }
    renderTabs() {
        const dataSkus = this.props.product.dataSkus;
        const topupSkus = this.props.product.skus;
        if (dataSkus.length === 0 || topupSkus.length === 0) return null;
        return (
            <ul id="orders-topup-plans" className="nav nav-tabs mb-3 font-weight-bold text-uppercase">
                <li className="nav-item">
                    <a className={classNames({ "topup-tab": true, "nav-link": true, active: !this.state.dataSku})}
                        href="javascript:void(0)"
                        onClick={e => this.onTabChanged(false)}>{t.common("top-up")}</a>
                </li>
                <li className="nav-item">
                    <a className={classNames({ "data-plan-tab": true, "nav-link": true, active: this.state.dataSku })}
                        href="javascript:void(0)"
                        onClick={e => this.onTabChanged(true)}>
                        <span>{t.common("plan")}</span>
                    </a>
                </li>
            </ul>
        );
    }
    renderTabsReverse() {
        const dataSkus = this.props.product.dataSkus;
        const topupSkus = this.props.product.skus;
        if (dataSkus.length === 0 || topupSkus.length === 0) return null;
        return (
            <ul id="orders-topup-plans" className="nav nav-tabs mb-3 font-weight-bold text-uppercase">
                <li className="nav-item">
                    <a className={classNames({ "data-plan-tab": true, "nav-link": true, active: this.state.dataSku })}
                        href="javascript:void(0)"
                        onClick={e => this.onTabChanged(true)}>
                        <span>{t.common("plan")}</span>
                        {/* <sup className="ml-1 text-success">{t.common("new")} !</sup> */}
                    </a>
                </li>
                <li className="nav-item">
                    <a className={classNames({ "topup-tab": true, "nav-link": true, active: !this.state.dataSku })}
                        href="javascript:void(0)"
                        onClick={e => this.onTabChanged(false)}>{t.common("top-up")}</a>
                </li>
            </ul>
        );
    }
    renderSkuList(skus: Sku[]) {
        const preferredSku = skus.find(s => s.preferred);
        const otherSkus = skus.filter(s => !s.preferred);
        return <>
            <div className="row">
                {preferredSku && <div data-id={preferredSku.skuId} key={preferredSku.skuId} className="col-12 preferred-sku">
                    {this.renderSku(preferredSku)}
                </div>}
            </div>
            <div className="row">
                {otherSkus.map(s => <div data-id={s.skuId} key={s.skuId} className="col-6 col-sm-4 col-md-3">
                    {this.renderSku(s)}
                </div>)}
            </div>
        </>
    }
    renderDataSkuList(dataSkus: Sku[]) {
        const preferredDataSku = dataSkus.find(s => s.preferred);
        const otherDataSkus = dataSkus.filter(s => !s.preferred);
        return <>
            {preferredDataSku && <div data-id={preferredDataSku.skuId} key={preferredDataSku.skuId} className="col-12 preferred-sku">
                {this.renderDataSku(preferredDataSku)}
            </div>}
            <div className="row">
                {otherDataSkus.map(s => <div key={s.skuId} className="col-12 col-sm-6">
                    {this.renderDataSku(s)}
                </div>)}
            </div>
        </>
    }
    render() {
        if (!this.props.product) return null;
        // const sort = (a: Sku, b: Sku) => {
        //     return (a.isPreferred ? 1 : 0) - (b.isPreferred ? 1 - 0);
        // }
        const skus = this.props.product.skus;
        const dataSkus = this.props.product.dataSkus;
        return (
            <React.Fragment>
                { this.props.showTopupTabFirst && this.renderTabs()}
                { !this.props.showTopupTabFirst && this.renderTabsReverse()}
                {(dataSkus.length > 0 && this.state.dataSku === true) &&
                    this.renderDataSkuList(dataSkus)}
                {(dataSkus.length === 0 || this.state.dataSku === false) &&
                    this.renderSkuList(skus)}
            </React.Fragment>
        );
    }
}
// const lineStyle: React.CSSProperties = {
//     color: "#f7a700",
//     fontSize: "16px",
//     fontWeight: 700,
//     lineHeight: "20px",
// }
// const footNoteStyle: React.CSSProperties = {
//     fontSize: "12px",
//     fontStyle: "italic",
//     fontWeight: "bold",
//     marginTop: 5
// }